import { LeaderboardsPageContainer } from '../../../shared/scripts/ui_leaderboard/LeaderboardsPageContainer.tsx';
import { LeaderboardsPageData } from '../../../shared/scripts/ui_leaderboard/LeaderboardsPageData.ts';
import { createLeaderboardsPageDataDeps } from '../../../shared/scripts/ui_leaderboard/createLeaderboardsPageDataDeps.ts';
import { createLeaderboardsNavigationCtaConfig } from '../../../shared/scripts/ui_leaderboard/createLeaderboardsNavigationCtaConfig.ts';
import { mountUIReactComponent } from '../../../shared/scripts/ui_platform/mountUIReactComponent.tsx';
import { UIUtilsEjsVariables } from '../../../shared/scripts/UIUtilsEjsVariables.ts';
import { navigateToPage } from '../../../shared/scripts/ui_utils/ClientUtils.ts';
import { showTranslucentOverlay } from '../../../shared/scripts/ui_overlays/showTranslucentOverlay.ts';
export class UIWLeaderboardController {
    // eslint-disable-next-line class-methods-use-this
    managesHistory() {
        return true;
    }
    // eslint-disable-next-line class-methods-use-this
    getInitialState() {
        return undefined;
    }
    // eslint-disable-next-line class-methods-use-this
    getOnRankedModeChange() {
        return undefined;
    }
    // eslint-disable-next-line class-methods-use-this
    getCtaConfig() {
        return createLeaderboardsNavigationCtaConfig();
    }
    static featureCheck() {
        const div = document.createElement('div');
        if (div.replaceChildren == undefined) {
            showTranslucentOverlay({
                title: {
                    key: 'strings:leaderboardPage.updateBrowser.title'
                },
                body: {
                    key: 'strings:leaderboardPage.updateBrowser.body'
                },
                onConfirm: ()=>navigateToPage('/')
            });
            throw new Error('Failed to create leaderboard: Browser does not support required features.');
        }
    }
    constructor(){
        UIWLeaderboardController.featureCheck();
        const managesHistory = this.managesHistory();
        this.data = new LeaderboardsPageData(createLeaderboardsPageDataDeps({
            manageHistory: managesHistory
        }), {
            hideMembership: UIUtilsEjsVariables.shouldHideStoreOnMobile,
            initialState: this.getInitialState(),
            parseStateFromUrl: managesHistory
        });
        mountUIReactComponent('leaderboard_root', LeaderboardsPageContainer).render({
            data: this.data,
            ctaConfig: this.getCtaConfig(),
            onRankedModeChange: this.getOnRankedModeChange()
        });
    }
}
